/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_ProfessionInputs */

const en_clients_field_profession = /** @type {(inputs: Clients_Field_ProfessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profession`)
};

const pt_br2_clients_field_profession = /** @type {(inputs: Clients_Field_ProfessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profissão`)
};

/**
* | output |
* | --- |
* | "Profession" |
*
* @param {Clients_Field_ProfessionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_profession = /** @type {((inputs?: Clients_Field_ProfessionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_ProfessionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_profession(inputs)
	return pt_br2_clients_field_profession(inputs)
});